import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getGaTrackingId, getGtmTrackingId } from 'reducers/marketplace/MarketplaceSelectors';
import { injectGA4, injectGTM } from 'utils/analytics';

export const useAnalyticsInjection = (): void => {
    const gtmTrackingId = useSelector(getGtmTrackingId);
    const gaTrackingId = useSelector(getGaTrackingId);

    useEffect(() => {
        if (gtmTrackingId) injectGTM(gtmTrackingId);
    }, [gtmTrackingId]);

    useEffect(() => {
        if (gaTrackingId) injectGA4(gaTrackingId);
    }, [gaTrackingId]);
};
